import request from 'services/request';
import { endpoints } from '../endpoints';

/**
 * 숏폼 목록 조회
 */
export const getShortsMediaList = async (): Promise<ShortsMediaDisplayListResDto> => {
  return request({
    method: 'GET',
    url: endpoints.shortsMedia.list,
  });
};

/**
 * 숏폼 상세 정보 조회
 */
export const getShortsMediaDetail = async (shortsMediaId: string): Promise<ShortsMediaContentsDetailResDto> => {
  return request({
    method: 'GET',
    url: endpoints.shortsMedia.detail.replace('{shortsMediaId}', shortsMediaId),
  });
};

/**
 * 숏폼 좋아요 수 증가
 */
export const addShortsMediaLike = async (shortsMediaId: string): Promise<BaseResDto> => {
  return request({
    method: 'POST',
    url: endpoints.shortsMedia.like.replace('{shortsMediaId}', shortsMediaId),
  });
};

/**
 * 숏폼 공유하기
 */
export const shareShortsMedia = async (params: ShareReqDto): Promise<BaseResDto> => {
  return request({
    method: 'PUT',
    url: endpoints.shortsMedia.share,
    data: params,
  });
};

/**
 * 풀영상 콘텐츠(롱퐁) 상세 정보 조회
 * @param mediaId
 */
export const getLongFormMediaDetail = async (mediaId: string): Promise<MediaDetailResDto> => {
  return request({
    method: 'GET',
    url: endpoints.shortsMedia.longFormDetail.replace('{mediaId}', mediaId),
  });
}

const shortsMedia = {
  getShortsMediaList,
  getShortsMediaDetail,
  addShortsMediaLike,
  shareShortsMedia,
  getLongFormMediaDetail,
};

export default shortsMedia;